import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPeople32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPeople32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 14a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m5.5-3.5c0 1.694-.766 3.21-1.97 4.218A9 9 0 0 1 22 23v2h5v-1.5a5.5 5.5 0 0 0-4-5.293V15.5a2.5 2.5 0 0 0-2-4.45V9.027Q21.246 9 21.5 9a4.5 4.5 0 0 1 3.165 7.699A7.5 7.5 0 0 1 29 23.5V27H4v-4a9 9 0 0 1 5.47-8.282A5.5 5.5 0 1 1 18.5 10.5M14 25h6v-2a7 7 0 1 0-14 0v2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPeople32);
